import { PublicClientApplication } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;
const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
const apiClientId = process.env.REACT_APP_ENTRA_API_CLIENT_ID;
const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE || "access_as_user";

if (!tenantId || !clientId || !apiClientId) {
  throw new Error(
    "Entra ID configuration missing: REACT_APP_ENTRA_TENANT_ID, REACT_APP_ENTRA_CLIENT_ID and REACT_APP_ENTRA_API_CLIENT_ID are required."
  );
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const loginRequest = {
  scopes: [`api://${apiClientId}/${apiScope}`],
};

export const msalInstance = new PublicClientApplication(msalConfig);
